import { AxiosError } from 'axios'
import { computed, flow, makeObservable, observable } from 'mobx'

import { openPdfDocumentFromBlob, requestWrapper } from 'Shared/utils'

import { ALL_OPTION, STORE_UI } from 'Core/constants'
import { CustomGenerator } from 'Core/interfaces'
import { entityToStringLabelValue, getDefaultStoreArrayValue } from 'Core/utils'

import { SiteVisitRepo } from 'Portals/Supplier/repositories'
import { RootStore } from 'Portals/Supplier/stores'

import { SiteVisitTable } from './SiteVisitTable'

export class SiteVisitStore {
	table: SiteVisitTable
	rootStore: RootStore
	@observable accessor availableSupplierLocations = getDefaultStoreArrayValue<Entity>()
	@observable accessor isDocumentDownloading: boolean = false

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
		this.table = new SiteVisitTable(rootStore)
	}

	@computed
	get availableSupplierLocationOptions() {
		return [ALL_OPTION, ...this.availableSupplierLocations.value.map(entityToStringLabelValue)]
	}

	@flow.bound
	*retrieveAvailableSupplierLocations(): CustomGenerator<Entity[]> {
		yield requestWrapper({
			field: this.availableSupplierLocations,
			repository: SiteVisitRepo.retrieveAvailableSupplierLocations,
			repositoryParams: null
		})
	}

	@flow.bound
	*downloadDocument(id: Key, fileName?: string): CustomGenerator<Blob> {
		if (!id) {
			return
		}

		this.isDocumentDownloading = true

		try {
			const document = yield SiteVisitRepo.downloadDocument(id)

			openPdfDocumentFromBlob(document, fileName)
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		} finally {
			this.isDocumentDownloading = false
		}
	}
}
